var DATAENGINE_DEFAULT_PORT = 4300;
var HTTPS_DEFAULT_PORT = 443;
var HTTP_DEFAULT_PORT = 80;

// responses
var HTTP_RESPONSE_OK = 200;
var HTTP_RESPONSE_NOT_FOUND = 404;
var HTTP_RESPONSE_CREATED = 201;
var HTTP_RESPONSE_NOT_MODIFIED = 304;

var DataEngineSettings = {
  "clientId": null,
  "bucket": null,
  "host": null,
  "port": null,
  path: '',
  apiKey: null,
  secure: false,
  noPersistentConnection: false
};

function encodeBucketOrKey(str) {
  if (typeof(str) == 'string') {
    return str.replace(/\//g, '%2F').replace(/\\/g, '%5C');
  } else {
    return str;
  }
}

var DataEngine = function(settings) {
  var self = this;
  
  if (settings == null) settings = {};
  
  // if settings are not specified use values from url
  settings.host = settings.host || location.hostname;
  settings.port = settings.port || location.port || ((location.protocol == 'https:') ? HTTPS_DEFAULT_PORT : HTTP_DEFAULT_PORT);
  settings.secure = settings.secure || (settings.port === HTTPS_DEFAULT_PORT)
  settings.clientId = settings.clientId || '';

  if (typeof settings.path !== 'string') settings.path = '';
  if ((settings.path !== '') && (settings.path.charAt(0) !== '/')) {
     settings.path = '/' + settings.path;
  }

  if (settings.path.charAt(settings.path.length -1) !== '/') {
    settings.path = settings.path + '/';
  }

  if (!settings.noPersistentConnection) {
    this.connection = new PersistentConnection(settings);
  }


  
  this.read = function(key, options) {
    options = options || {};
    var bucket = options.bucket || settings.bucket;
    if (options.async == null) options.async = true;

    return this.request({
      url: self.getUrl(key, bucket, options.keysOnly, options.filter),
      bucket: bucket,
      method: 'GET',
      key: key,
      keysOnly: options.keysOnly,
      filter: options.filter,
      async: options.async,
      forceHttp: options.forceHttp
    });
  }

  this.write = function(key, value, options) {
    options = options || {};
    var bucket = options.bucket || settings.bucket;
    if (options.async == null) options.async = true;
    
    return this.request({
      url: self.getUrl(key, bucket),
      key: key,
      bucket: bucket,
      data: value,
      failIfExists: options.failIfExists,
      expire: options.expire,
      method: ((key) ? 'PUT' : 'POST'),
      async: options.async,
      forceHttp: options.forceHttp
    });
  }

  this.patch = function(key, patch, options) {
    options = options || {};
    var bucket = options.bucket || settings.bucket;
    if (options.async == null) options.async = true;

    return this.request({
      url: self.getUrl(key, bucket, options),
      key: key,
      bucket: bucket,
      data: patch,
      method: 'PATCH',
      async: options.async,
      forceHttp: options.forceHttp
    });
  }

  this.remove = function(key, options) {
    options = options || {};
    var bucket = options.bucket || settings.bucket;
    if (options.async == null) options.async = true;
    
    return this.request({
      url: self.getUrl(key, bucket),
      method: 'DELETE',
      key: key,
      bucket: bucket,
      async: options.async,
      forceHttp: options.forceHttp
    });
  }

  this.getUrl = function(key, bucket, keysOnly, filter) {
    if (!key) key = '';
    // add "unique" suffix to prevent caching
    var suffix = 'd=' + new Date().valueOf();
    suffix = ((key.indexOf('?') > -1) ? '&' : '?') + (keysOnly?'keysOnly=true&':'') + (filter?'filter=' + filter + '&':'') + suffix;
    
    // build url
    var protocol = settings.secure ? 'https://' : 'http://';
    var url = protocol + settings.host + ':' + settings.port + settings.path + '_data/' + encodeURIComponent(bucket) + '/' + encodeURIComponent(key) + suffix;
    return url;
  }

  this.request = function(options) {
    if (options.async === undefined)
      options.async = true;
    // if we have a websocket running use that channel instead
    if ((self.connection) && (options.async) && (self.connection.connected) && (!options.forceHttp)) {
      return self.connection.request(options);  
    }
    return new Promise(function(resolve, reject) {
      var req = new XMLHttpRequest();
      var method = options.method || 'GET';
      req.open(method, options.url, options.async);

      if (settings.apiKey) {
        req.setRequestHeader('API-Key', options.apiKey);
      }

      if (['POST', 'PUT', 'PATCH'].indexOf(method) > -1) {
        req.setRequestHeader('Content-Type', 'application/json');
        if (options.failIfExists) {
          req.setRequestHeader('FailIfExists', 'true');
        }
        if (options.expire) {
          req.setRequestHeader('Expire', options.expire);
        }

        options.data = JSON.stringify(options.data);
      }

      req.onload = function() {
        // 200 (ok) or 304 (not modified)
        if ((method === 'GET') && ([HTTP_RESPONSE_OK, HTTP_RESPONSE_NOT_MODIFIED].indexOf(req.status) > -1)) {
          var serverTime = req.getResponseHeader('X-Timestamp');
          var obj = JSON.parse(req.response);
          obj.__serverTime = serverTime;
          resolve(obj);

          // 200 (ok) or 201 (created)
        } else if ((['POST', 'PUT', 'PATCH'].indexOf(method) > -1) && ([HTTP_RESPONSE_OK, HTTP_RESPONSE_CREATED].indexOf(req.status) > -1)) {
          var key = options.key;
          if (req.status === HTTP_RESPONSE_CREATED) {
            // created
            key = req.getResponseHeader('Location');
          }
          resolve(key);

          // 200 (ok) only. 404 (not found / already deleted) will reject
        } else if ((method === 'DELETE') && (req.status === HTTP_RESPONSE_OK)) {
          resolve(key);
        } else {
          reject(Error(req.statusText));
        }
      };

      req.onerror = function() {
        reject(Error("Network error"));
      };

      req.send(options.data);
    });
  }
  this.close = function() {
    this.connection.close();
  }
}

var PersistentConnection = function(settings) {
  var self = this;
  this.events = [];
  this.sendValues = false;
  this.ws = null;
  this.connected = false;
  this.eventsReceived = 0;
  this.skipReconnect = false;

  this.close = function() {
    this.events = [];
    this.skipReconnect = true;
    self.ws.close();
    self.ws = null;
  }

  this.onConnect = function() {};
  this.onDisconnect = function() {};

  this.request = function(options) {
    if (!options.key) options.key = '';
    var bucket = options.bucket || settings.bucket;
    var method = options.method || 'GET';
    if (method === 'GET') {
      return this.read(bucket, options.key);
    } else if ((method === 'POST') || (method === 'PUT')) {
      return this.write(bucket, options.key, options.data, options.failIfExists, options.expire);
    } else if (method === 'DELETE') {
      return this.delete(bucket, options.key);
    } else if (method === 'PATCH') {
      return this.patch(bucket, options.key, options.data);
    } else if (method === 'EVENT') {
      return this.signalEvent(bucket, options.key, options.data);
    }
  }
  
  this.requests = [];
  var REQUEST_TIMEOUT = 1000;
                       
  this.read = function(bucket, key, filter, keysOnly) {
    return new Promise(function(resolve, reject) {
      var op = 'read';
      if ((key == null) || (key == '') && (filter != null)) {
        op = 'filter';
      }
      
      self.addRequest({op: op, bucket: bucket, key: key, filter: filter, keysOnly: keysOnly}, function(err, obj) {
        if (err) {
          reject('DataEngine ws READ error: ' + JSON.stringify(err) + ' for bucket: ' + bucket + ', key: ' + key);
        } else {
          resolve(obj);
        }
      });
    });
  }
  
  this.write = function(bucket, key, value, failIfExists, expire) {
    return new Promise(function(resolve, reject) {
      self.addRequest({op: 'write', bucket: bucket, key: key, value: value, failIfExists: failIfExists, expire: expire}, function(err, location) {
        if (err) {
          reject('DataEngine ws WRITE error: ' + JSON.stringify(err) + ' for bucket: ' + bucket + ', key: ' + key);
        } else {
          resolve(location);
        }
      });
    });
  }
  
  this.patch = function(bucket, key, patch) {
    return new Promise(function(resolve, reject) {
      self.addRequest({op: 'patch', bucket: bucket, key: key, patch: patch}, function(err, result) {
        if (err) {
          reject('DataEngine ws PATCH error: ' + JSON.stringify(err) + ' for bucket: ' + bucket + ', key: ' + key);
        } else {
          resolve(result);
        }
      });
    });
  }

  this.delete = function(bucket, key) {
    return new Promise(function(resolve, reject) {
      self.addRequest({op: 'remove', bucket: bucket, key: key}, function(err) {
        if (err) {
          reject('DataEngine ws REMOVE error: ' + JSON.stringify(err) + ' for bucket: ' + bucket + ', key: ' + key);
        } else {
          resolve();
        }
      });
    });
  }
  
  this.signalEvent = function(bucket, key, value) {
    var eventObj = {bucket: bucket, key: key, value: value}
    self.ws.send(JSON.stringify({msg: 'event-broadcast', event: eventObj}));
  }
  
  this.requestID = 0;
  
  this.addRequest = function(obj, callback) {
    self.requestID = self.requestID + 1; 
    self.requests[self.requestID] = {timeStamp: new Date(), callback: callback};
    obj.id = self.requestID + '';

    self.ws.send(JSON.stringify({msg: 'datastore-operation', request: obj}));
  }
  
  this.handleReponse = function(response) {
    if (self.requests[response.id]) {
      self.requests[response.id].callback(response.error, response.value || response.location);
      self.requests[response.id] = null;
    }
  }
  
  this.checkRequestTimeouts = function() {
    setTimeout(function() {
      for (var i in self.requests) {
        var req = self.requests[i + ''];
        if (req) {
          var now = new Date();
          if (now - self.requests[i].timeStamp > REQUEST_TIMEOUT) {
            req.callback('Timeout occured for request ' + req.id);
            self.requests[i] = null;
          }
        }
      }
      self.checkRequestTimeouts();
    }, 1000);
  }
  
  this.checkRequestTimeouts();
    
  this.addListener = function(bucket, key, sendValues, callback) {
    if (sendValues) this.sendValues = true;
    this.events.push({
      bucket: bucket,
      key: key,
      callback: callback
    });
    this.registerEvents();
  }
  
  this.removeListener = function(method) {
    var i = this.events.length;
    var wasRemoved = false;
    while (i--) {
      if (this.events[i].callback === method) {
        this.events.splice(i, 1);
        wasRemoved = true;
      }
    }
    if (wasRemoved) {
      this.registerEvents();
    }
  }

  this.registerEvents = function() {
    if (self.connected) {
      var eventMap = [];
      var eventArr = [];
      for (var i = 0; i < self.events.length; i++) {
        var eventJson = JSON.stringify(self.events[i]);
        // avoid adding duplicates
        if (!eventMap[eventJson]) {
          eventArr.push({
            bucket: self.events[i].bucket,
            key: self.events[i].key
          });
          eventMap[eventJson] = true;
        }
      }
      self.ws.send(JSON.stringify({
        msg: 'register-events',
        events: eventArr,
        sendValues: self.sendValues
      }));
    }
  }

  var protocol = (settings.secure) ? 'wss://' : 'ws://';
  wsStart(protocol + settings.host + ':' + settings.port + settings.path);

  function wsStart(url) {
    self.skipReconnect = false;
    self.connected = false;
    window.WebSocket = window.WebSocket || window.MozWebSocket;
    self.ws = new WebSocket(url + "?id=" + settings.clientId);
    self.ws.onmessage = function(evt) {
      var eventObj = JSON.parse(evt.data);
      
      if (eventObj.id) {
        self.id = eventObj.id;
        self.onConnect(self);
        return;
      }
      
      if (eventObj.response) {
        self.handleReponse(eventObj.response);
        return;
      }
      
      self.eventsReceived++;
      var value = ((typeof eventObj.value !== 'undefined') && (typeof eventObj.isDeleted === 'undefined')) ? eventObj.value : null;
      var obj = {
        bucket: eventObj.bucket,
        key: eventObj.key,
        value: value,
        originRequestId: eventObj.originRequestId,
        clientId: eventObj.clientId
      };
      if (eventObj.isDeleted)
        obj.isDeleted = true;
      // fire events
      for (var i = 0; i < self.events.length; i++) {
        if (((self.events[i].bucket === '*') || (self.events[i].bucket == obj.bucket)) &&
          ((self.events[i].key === '*') || (self.events[i].key == obj.key))) {
          self.events[i].callback(obj);
        }
      }
    };

    self.ws.onopen = function() {
      self.connected = true;
      self.registerEvents();
    };

    self.ws.onclose = function() {
      if (self.connected) {
        self.connected = false;
        self.onDisconnect(self);
      }
      //reconnect loop
      setTimeout(function() {
        if (!self.skipReconnect) {
          wsStart(url)
        }
      }, 3000);
    };
  }
}

if (typeof module === "object" && typeof module.exports === "object" ) {
  module.exports = DataEngine;
}


// WEBPACK FOOTER //
// ./public/js/de.js